import React, {useState, useEffect, useRef} from "react";
import Menu from "../../../../components/layout/menu/index";
import banner from "../../../../assets/images/logos/banner-benefits.svg"
import uploadImage from "../../../../assets/images/icons/benefits/uploadImageBenefits.svg"
import {getBenefits, createBenefit, softDeleteBenefitId, updateBenefitId, visibleBenefitId } from '../../../../client/administration/benefits/index';
import barColor from "../../../../assets/images/icons/benefits/bar-color.svg"
import ModalColorPicker from "../../../../components/shared/modals/modalColorPicker";
import ModalSuccess from "../../../../components/shared/modals/modalSuccess";
import ModalDelete from "../../../../components/shared/modals/modalDelete";
import BenefitCard from "../../../../components/card/benefitCardAdmin";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ModalAlertPercente from "../../../../components/shared/modals/modalAlertPercente";
import ModalAlertWarning from "../../../../components/shared/modals/modalAlertWarning";

export default function Benefits() {

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const [benefits, setBenefits] = useState([]);
const [showModalWarning, setShowModalWarning] = useState(false);
const [modalWarningMessage, setModalWarningMessage] = useState("");

  //Estados para el formulario de creacion y edicion
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [percente, setPercente] = useState("");
  const [selectedColor, setSelectedColor] = useState('#23B7EA');
  const [selectedImage, setSelectedImage] = useState(null);

  const [showModalColorPicker, setShowModalColorPicker] = useState(false);
  const [showModalSuccess, setShowModalSuccess] = useState(false);
  const [modalSuccessText, setModalSuccessText] = useState("");

  // Estados para el modal de eliminación
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [benefitToDelete, setBenefitToDelete] = useState(null);

  //Editar beneficio
  const [selectedBenefit, setSelectedBenefit] = useState(null);

  const [formTitle, setFormTitle] = useState("Agregar beneficio"); 

  //filtros
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const [filterText, setFilterText] = useState("Filtros");
  const [isFilterActive, setIsFilterActive] = useState(false);

  const [showByPercentage, setShowByPercentage] = useState(false);
  const [sortOrder, setSortOrder] = useState('asc');
  const [groupedBenefits, setGroupedBenefits] = useState({});
  const [showByExclusive, setShowByExclusive] = useState(false);
  const [showByColor, setShowByColor] = useState(false);

  const [showModalAlertPercente, setShowModalAlertPercente] = useState(false);
  const quillRef = useRef(null);

const charCount = description ? 
  new DOMParser().parseFromString(description, 'text/html').body.textContent?.length || 0 
  : 0;
const isNearLimit = charCount > 180;

const handleDescriptionChange = (content, delta, source, editor) => {
  const plainText = editor.getText();
  const currentCharCount = plainText.length;
  
  if (currentCharCount <= 201) {
    setDescription(content);
  } else {
    const quill = quillRef.current?.getEditor();
    if (quill) {
      quill.setContents(quill.clipboard.convert(description));
    }
  }
};
  const hexToNumber = (hex) => {
    return parseInt(hex.replace("#", ""), 16);
  };

const toggleSortOrder = () => {
  setSortOrder(prevOrder => (prevOrder === 'asc' ? 'desc' : 'asc'));

  if (showByPercentage) {
    const sortedGrouped = Object.entries(groupedBenefits).sort(([a], [b]) => {
      return sortOrder === 'asc' ? Number(a) - Number(b) : Number(b) - Number(a);
    });
    setGroupedBenefits(Object.fromEntries(sortedGrouped));
  } else if (showByExclusive) {
    const sortedGrouped = Object.entries(groupedBenefits).sort(([a], [b]) => {
      return sortOrder === 'asc' ? a.localeCompare(b) : b.localeCompare(a);
    });
    setGroupedBenefits(Object.fromEntries(sortedGrouped));
  } else if (showByColor) {
    const sortedGrouped = Object.entries(groupedBenefits).sort(([a], [b]) => {
      const colorA = hexToNumber(a);
      const colorB = hexToNumber(b);
      return sortOrder === 'asc' ? colorA - colorB : colorB - colorA;
    });
    setGroupedBenefits(Object.fromEntries(sortedGrouped));
  }
};

  const sortedGroupedBenefits = Object.entries(groupedBenefits).sort(([percenteA], [percenteB]) => {
    return sortOrder === 'asc' 
        ? Number(percenteA) - Number(percenteB) 
        : Number(percenteB) - Number(percenteA);
  });

  const handleGroupByPercentage = async () => {
    try {
      const response = await getBenefits("groupByPercente");
      setGroupedBenefits(response.data.groupedBenefits);
      setShowByPercentage(true);
      setShowByExclusive(false);
      setShowByColor(false);
      setFilterText("Porcentaje");
      setIsFilterActive(true);
    } catch (error) {
      console.error("Error al obtener los beneficios agrupados por porcentaje:", error);
    }
  };
  
  const handleGroupByExclusive = async () => {
    try {
      const response = await getBenefits("groupByExclusive");
      setGroupedBenefits(response.data.groupedByExclusive);
      setShowByPercentage(false);
      setShowByExclusive(true);
      setShowByColor(false);
      setFilterText("Exclusivo");
      setIsFilterActive(true);
    } catch (error) {
      console.error("Error al obtener los beneficios agrupados por exclusividad:", error);
    }
  };

  const handleGroupByColor = async () => {
    try {
      const response = await getBenefits("groupByColor");
      const sortedGrouped = Object.entries(response.data.groupedByColor).sort(([colorA], [colorB]) => {
        return hexToNumber(colorA) - hexToNumber(colorB); // Orden ascendente inicial
      });

      setGroupedBenefits(Object.fromEntries(sortedGrouped));
      setShowByPercentage(false);
      setShowByExclusive(false);
      setShowByColor(true);
      setFilterText("Color");
      setIsFilterActive(true);
    } catch (error) {
      console.error("Error al obtener los beneficios agrupados por color:", error);
    }
  };
  

//editar 
  const scrollToTop = () => {
    window.scrollTo({ top: 230, behavior: "smooth" });
  };

  const handleEditClick = (benefit) => {
    setSelectedBenefit(benefit);
    setTitle(benefit.title);
    setDescription(benefit.description);
    setPercente(benefit.percente);
    setSelectedColor(benefit.color);
    setFormTitle("Editar beneficio"); 
    setSelectedImage(benefit.image || null);
    scrollToTop();
  };

  const handleCancelEdit = () => {
    setSelectedBenefit(null);
    setTitle("");
    setDescription("");
    setPercente("");
    setSelectedColor("#23B7EA");
    setFormTitle("Agregar beneficio");
    setSelectedImage(null);

    if (showByPercentage) {
      handleGroupByPercentage();
    } else if (showByExclusive) {
      handleGroupByExclusive();
    } else if (showByColor) {
      handleGroupByColor();
    }
  };
  
  const handleCloseModalSuccess = () => {
    setShowModalSuccess(false);
    handleCancelEdit();
  };

//listar
  useEffect(() => {
    const fetchBenefits = async () => {
      try {
        const response = await getBenefits();
        setBenefits(response.data);
      } catch (error) {
        console.error("Error fetching benefits:", error);
      }
    };

    fetchBenefits();
  }, []);

  const percenteValue = percente ? String(percente).trim() : "";
  const isFormValid = title.trim() !== "" && description.trim() !== "" && percenteValue !== "";

  const openModalColorPicker = () => {
    setShowModalColorPicker(true); 
  }
  
  const handleSaveBenefit = async () => {
    if (!isFormValid) return; 

    const newPercente = Number(percente);

    const existingPercentages = [...new Set(benefits.map(b => Number(b.percente)))];

    if (existingPercentages.length >= 5 && !existingPercentages.includes(newPercente)) {
      setShowModalAlertPercente(true);
      return;
    }

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("percente", newPercente); 
    formData.append("color", selectedColor);

    if (selectedImage) {
      formData.append("image", selectedImage);
    }

    try {
        const token = localStorage.getItem("token");

        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data" 
            }
        };

        if (selectedBenefit) {
          await updateBenefitId(selectedBenefit.id, formData, config);
          setModalSuccessText("¡Su beneficio fue editado con éxito!");
        } else {
          await createBenefit(formData, config);
          setModalSuccessText("¡Su beneficio fue registrado con éxito!");
        }
    
        const response = await getBenefits();
        setBenefits(response.data);
        
        if (showByPercentage) {
          handleGroupByPercentage(); 
        } else if (showByExclusive) {
          handleGroupByExclusive(); 
        } else if (showByColor) {
          handleGroupByColor();
        }
    
        setShowModalSuccess(true);
    
        setTimeout(() => {
          handleCancelEdit();
        }, 500);
        
    } catch (error) {
        console.error("Error creando el beneficio:", error.response?.data || error.message);
    }
};

const handlePercenteChange = (e) => {
    let value = e.target.value;
  
    if (!isNaN(value) && value !== "") {
      value = Math.min(Number(value), 100);
    } else {
      value = "";
    }
  
    setPercente(value);
  };

//eliminar
  const handleDeleteClick = (id) => {
    setBenefitToDelete(id);
    setShowModalDelete(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      };

      await softDeleteBenefitId(benefitToDelete, config);
      setBenefits((prev) => prev.filter((b) => b.id !== benefitToDelete));

      if (showByPercentage) {
        handleGroupByPercentage(); 
      } else if (showByExclusive) {
        handleGroupByExclusive(); 
      } else if (showByColor) {
        handleGroupByColor();
      }

      setShowModalDelete(false);

      setModalSuccessText("¡Su beneficio fue eliminado con éxito!");
      setShowModalSuccess(true);
    } catch (error) {
      console.error("Error eliminando beneficio:", error.response?.data || error.message);
    }
  };

  const handleToggleVisibility = async (id, isVisible) => {
    try {
        const token = localStorage.getItem("token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        };

        await visibleBenefitId(id, { visible: !isVisible }, config);
        
        setBenefits(prevBenefits => 
            prevBenefits.map(benefit => 
                benefit.id === id ? { ...benefit, visible: !isVisible } : benefit
            )
        );

        if (showByPercentage) {
            handleGroupByPercentage();
        } else if (showByExclusive) {
            handleGroupByExclusive();
        } else if (showByColor) {
            handleGroupByColor();
        }

        setModalSuccessText(`Beneficio ${isVisible ? "ocultado" : "mostrado"} con éxito!`);
        setShowModalSuccess(true);
    } catch (error) {
        console.error("Error al cambiar visibilidad:", error.response?.data || error.message);
    }
};


  return (
    <div>
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300"/>
      <div className={`flex-1 transition-all duration-300 pt-[67px]  bg-[#F7F8F9] w-full z-50 min-h-screen ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"}`}>
        <div className="pt-4 md:pt-8 pb-10 px-[3%]">
            <div className="flex flex-col gap-3">
                <img src={banner} alt="Beneficios especiales" className="w-full"/>
                <div className="grid grid-cols-1 gap-6 pt-4 sm:grid-cols-3 ">
                  <div className="flex flex-col justify-start h-full gap-2">
                      <h2 className="text-blue font-itcmedium text-[24px] sm:text-[20px] md:text-[24px]">{formTitle}</h2>
                      <div className="rounded-[15px] flex flex-col justify-center items-center border-[1px] border-[#D1D5DB] flex-grow p-8">
                        <label 
                          htmlFor="upload-image"
                          className="cursor-pointer rounded-[15px] drop-shadow-uploadImage p-8 py-6   flex justify-center flex-col items-center border-[1px] border-[#D1D5DB] border-dashed bg-[#EFEFEF]">
                            <input 
                              type="file" 
                              accept=".jpg,.jpeg,.png,.webp,.svg"
                            onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (!file) return;

                                    const validTypes = [
                                      "image/jpeg",
                                      "image/png",
                                      "image/webp",
                                      "image/svg+xml",
                                    ];

                                    if (!validTypes.includes(file.type)) {
                                      setModalWarningMessage("Formato no permitido. Solo se aceptan JPG, PNG, WEBP o SVG.");
                                      setShowModalWarning(true);
                                      e.target.value = "";
                                      return;
                                    }

                                    if (file.size > 50 * 1024 * 1024) {
                                      setModalWarningMessage("El archivo supera el peso máximo permitido de 50 MB.");
                                      setShowModalWarning(true);
                                      e.target.value = "";
                                      return;
                                    }
                                    setSelectedImage(file);
                                  }}
                                  className="hidden"
                                  id="upload-image"
                            />
    
                            <img src={uploadImage} alt="Subir"/>
                            <div className="flex items-center justify-center gap-3 pt-3">
                              <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1_8618)">
                                <path d="M5.54737 11.477C4.22227 11.477 2.89717 11.4781 1.57207 11.4763C1.06289 11.4756 0.663075 11.1177 0.562807 10.579C0.554034 10.5327 0.548707 10.4844 0.548707 10.4371C0.54714 9.8514 0.544007 9.26569 0.547454 8.67999C0.54902 8.43549 0.693156 8.23759 0.899645 8.16907C1.10237 8.1016 1.31419 8.17916 1.44297 8.36662C1.52005 8.47896 1.54293 8.60696 1.54261 8.74573C1.54105 9.24031 1.54512 9.73488 1.53979 10.2295C1.53854 10.3397 1.56862 10.3658 1.66481 10.3658C4.25235 10.363 6.8402 10.3627 9.42774 10.3665C9.53678 10.3665 9.55496 10.3268 9.55402 10.218C9.54963 9.70601 9.54963 9.19405 9.55402 8.68208C9.55621 8.44314 9.69502 8.24454 9.89273 8.17255C10.0933 8.09951 10.3088 8.17081 10.4411 8.35445C10.5144 8.45636 10.5485 8.57357 10.5485 8.70434C10.5479 9.26396 10.5548 9.82392 10.546 10.3835C10.5363 11.0044 10.1055 11.4711 9.5465 11.4756C8.97591 11.4802 8.40501 11.4767 7.83442 11.4767C7.07207 11.4767 6.31004 11.4767 5.54769 11.4767L5.54737 11.477Z" fill="black"/>
                                <path d="M5.04934 3.25715C4.75355 3.54409 4.48314 3.80668 4.21304 4.06857C4.10118 4.17709 3.9912 4.28769 3.87683 4.39273C3.65749 4.5948 3.3523 4.57254 3.17151 4.34508C2.98852 4.11483 3.00168 3.77329 3.21569 3.56356C3.88372 2.90934 4.55458 2.25895 5.22762 1.61134C5.4197 1.42631 5.67758 1.4277 5.87122 1.61377C6.54427 2.26139 7.21512 2.91178 7.88253 3.56669C8.0956 3.77572 8.10563 4.12214 7.92138 4.3489C7.73808 4.57463 7.43226 4.59689 7.21575 4.39029C6.86042 4.05084 6.50949 3.70581 6.15604 3.36392C6.12753 3.3361 6.10434 3.29888 6.06079 3.28845C6.03196 3.33575 6.047 3.38897 6.047 3.43801C6.04606 5.17285 6.04637 6.9077 6.04575 8.64254C6.04575 8.98269 5.88595 9.20285 5.61021 9.24876C5.34325 9.29328 5.08004 9.06756 5.05372 8.76914C5.04808 8.70445 5.04934 8.63906 5.04934 8.57402C5.04934 6.86526 5.04934 5.1565 5.04934 3.4474C5.04934 3.39662 5.04934 3.34584 5.04934 3.25715Z" fill="black"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_1_8618">
                                <rect width="10.0042" height="10.5015" fill="white" transform="translate(0.545898 0.611938)"/>
                                </clipPath>
                                </defs>
                              </svg>
                              <p className="text-[#3F3F3F] text-[10px]">Sube una foto</p>
                                </div>
                        </label>
                        <p className="text-[10px] pt-3 text-center text-[#6B7280] font-itcbook">
                            Formatos permitidos: JPG, PNG, WEBP, SVG <br />
                            Peso máx. 50 MB · Medida ideal: 123 px × 97 px
                          </p>
                      </div>
                        
                      <p className="text-blue font-itcmedium text-[20px] sm:text-[16px] md:text-[20px]">Escoger color</p>
                        <img
                            onClick={openModalColorPicker}
                            className="cursor-pointer" src={barColor} alt="Selector de color"
                        />
                  </div> 
                  <ModalColorPicker
                    showModalColorPicker={showModalColorPicker} 
                    closeModalColorPicker={() => setShowModalColorPicker(false)}
                    setSelectedColor={setSelectedColor}
                  />

                  <div className="flex flex-col justify-between flex-grow h-full gap-3">
                    <div className="flex flex-col gap-3">
                      <p className="text-blue font-itcmedium text-[20px] sm:text-[16px] md:text-[20px]">Título <span className="text-red-500">*</span></p>
                      <textarea
                        value={title}
                        onChange={(e) => {
                          if (e.target.value.length <= 50) {
                            setTitle(e.target.value);
                          }
                        }}
                        className="p-2 border-[1px] border-[#D1D5DB] rounded-[10px] outline-none placeholder:font-itcbook placeholder:text-[14px] text-[14px]"
                        placeholder="Describa"
                      />
                    </div>
                    <div className="flex flex-col gap-3">
                      <p className="text-blue font-itcmedium text-[20px] sm:text-[16px] md:text-[20px]">Especificación <span className="text-red-500">*</span></p>
                      <style>
                        {`
                        .ql-container {
                           border-bottom-left-radius: 10px !important;
                           border-bottom-right-radius: 10px !important;
                           background-color: white;
                           height: 115px !important;
                        }
                        .ql-toolbar {
                        border-top-right-radius: 10px !important;
                        border-top-left-radius: 10px !important;
                        background-color: white;
                        }
                        .quill {
                        }
                        `}
                      </style>
                      <ReactQuill
                        ref={quillRef}
                        value={description}
                        onChange={handleDescriptionChange}
                        modules={{
                          toolbar: [
                            ['bold', 'italic', 'underline'],
                          ]
                        }}
                        formats={[
                          'bold', 
                          'italic', 
                          'underline',
                        ]}
                        className="overflow-visible outline-none "
                        style={{  overflow: 'visible'}} 
                      />

                      <div className={`text-xs text-right font-itcbook ${isNearLimit ? 'text-red' : 'text-gray'}`}>
                        {charCount}/200 caracteres
                      </div>
                    </div>
                    <div className="flex flex-col gap-3">
                      <p className="text-blue font-itcmedium text-[20px] sm:text-[16px] md:text-[20px]">Especificar porcentaje <span className="text-red-500">*</span></p>
                      <div className="border-[1px] bg-white  flex rounded-[6px] border-[#D1D5DB]">
                        <input
                          type="number"
                          value={percente}
                          onChange={handlePercenteChange}
                          min="0"
                          max="100"
                          className="rounded-l-[6px] w-full outline-none p-2 placeholder:font-itcbook placeholder:text-[14px] text-[14px]"
                          placeholder="Describa"/>
                          <p className="text-[#5A5A5A] p-2 border-l-[1px] text-center border-[#D1D5DB] w-[45px] text-[14px] font-itcdemi">%</p>
                      </div>        
                    </div>
                  </div>
                  <div className="pt-10">
                    <div className="border-[#007696]  border-[1px] border-dashed flex flex-col justify-start rounded-[16px] p-4 h-full">
                      <div>
                        <p className="text-blue font-itcmedium text-[24px] sm:text-[20px] md:text-[24px]">Previsualización:</p>
                      </div>
                      <div className="flex items-center justify-center gap-2 py-10 sm:flex-col lg:flex-row">      
                        <div
                          style={{ backgroundColor: selectedColor }} 
                          className="p-2 gap-1 w-[135px] h-[167px] rounded-lg flex flex-col">
                          {selectedImage ? (
                            <img 
                              src={
                                typeof selectedImage === 'string' 
                                  ? selectedImage 
                                  : URL.createObjectURL(selectedImage) 
                              } 
                              alt="Vista previa"
                              className="object-fill w-[123px] h-[97px] rounded-[4.48px]" />
                          ) : (
                            <>
                            <img src={uploadImage} alt="Subir" className="w-[123px] h-[97px] rounded-[4.48px]" />
                            </>
                          )}
                          <p className=" text-[11px] leading-[10.4px] text-left font-itcmedium text-white break-words whitespace-normal">
                            {title || "Título"}
                          </p>
                                     
                          {percente > 90 && percente <= 100 && (
                            <p className="text-[8px] tracking-wider text-left font-itcbold text-white">
                              EXCLUSIVO
                            </p>
                          )}              
                        </div>

                      <style>
                        {`

                        .link a {
                          color: #3b82f6 !important; 
                          text-decoration: underline !important; 
                        }
                        `}
                      </style>
    
                        <div
                          style={{ backgroundColor: selectedColor }} 
                          className="w-[135px] h-[167px] rounded-lg  flex items-start justify-start ">
                          <div 
                            className="text-[11px] p-2 leading-[11px] link font-itcmedium text-white break-words whitespace-normal overflow-hidden"
                            dangerouslySetInnerHTML={{
                              __html: (description || "Especificación").split(/\s+/).slice(0, 200).join(' ')
                            }}
                            style={{ 
                              color: 'white',
                              hyphens: 'auto',
                              WebkitHyphens: 'auto',
                              msHyphens: 'auto'
                            }}
                          />
                        </div>   
                      </div>
                    </div>
                  </div>

                </div>

                <div className="flex items-center justify-center gap-10 mt-12">
                  <button 
                    onClick={handleSaveBenefit}
                    disabled={!isFormValid}
                    className={`w-[310px] text-white rounded-[16px] text-[18px] font-itcdemi h-[64px] p-2 
                      ${isFormValid 
                        ? "bg-[#FFC000] " 
                        : "bg-[#D9D9DB]  cursor-not-allowed"}`}
                  >
                    Guardar
                  </button>
                  <button 
                    disabled={!isFormValid}
                    onClick={handleCancelEdit}
                    className={`w-[310px] border-[3px] rounded-[16px] text-[18px] bg-transparent font-itcdemi h-[64px] p-2 
                      ${isFormValid 
                        ? " border-[#FFC000] text-[#FFC000] " 
                        : " border-[#D9D9DB] text-[#D9D9DB]  cursor-not-allowed"}`}
                  >
                    Cancelar
                  </button>
                </div>

                <div className="w-full h-[1px] bg-[#D9D9D9] my-6"></div>
                <div className="flex items-center justify-between">
                    <h2 className="text-blue text-[24px] sm:text-[20px] md:text-[24px] font-itcmedium">Lista de Beneficios</h2>
                    <div className="flex items-center justify-center gap-4">
                      {isFilterActive && (
                      <button id="filter-asc" className="cursor-pointer" onClick={toggleSortOrder}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.181 2.86499V19.365M20.931 16.677L17.181 20.1165L13.431 16.677M6.75 2.99999V21M10.5 6.74999L6.75 3.31049L3 6.74999" stroke="#6B7280" stroke-width="1.5"/>
                        </svg>
                      </button>
                      )}

                      <div className="relative inline-block">
                          <button
                              className="text-[#52526C] h-[32px] text-sm flex items-center justify-center w-[141px] border-[#5CBDEB] rounded-lg p-1 px-2 border-[1px] font-itcmedium"
                              onMouseEnter={() => setIsOpenFilter(true)}
                              onMouseLeave={() => setIsOpenFilter(false)}
                          >
                              <p>{filterText}</p>
                              {isFilterActive && (
                                <button 
                                    onClick={() => {
                                        setShowByPercentage(false);
                                        setIsFilterActive(false); 
                                        setShowByExclusive(false);
                                        setShowByColor(false);
                                        setFilterText("Filtros");
                                    }} 
                                    className="ml-2 px-2 font-itcbold text-black text-[14px] cursor-pointer"
                                >
                                    X
                                </button>
                              )}
                          </button>
  
                          {isOpenFilter && (
                              <div
                              className="absolute z-20 left-0 top-[25px] w-[141px] bg-white border-[1px] border-[#5CBDEB] overflow-hidden rounded-b-lg shadow-lg"
                              onMouseEnter={() => setIsOpenFilter(true)}
                              onMouseLeave={() => setIsOpenFilter(false)}
                              >
                                <ul className="text-[#52526C] flex flex-col justify-center items-center text-[14px] font-itcmedium">
                                    <li 
                                      onClick={handleGroupByPercentage}
                                      className="w-full p-2 px-3 hover:bg-[#5CBDEB] hover:bg-opacity-10 cursor-pointer ">
                                      Porcentaje
                                    </li>
                                    <div className="w-[90%] h-[1px] bg-[#5CBDEB]"></div>
                                    <li 
                                      onClick={handleGroupByExclusive}
                                      className="w-full p-2 px-3  cursor-pointer  hover:bg-[#5CBDEB] hover:bg-opacity-10 ">
                                        Tipo
                                    </li>
                                    <div className="w-[90%] h-[1px] bg-[#5CBDEB]"></div>
                                    <li
                                      onClick={handleGroupByColor}
                                      className="w-full p-2 px-3 cursor-pointer hover:bg-[#5CBDEB] hover:bg-opacity-10">
                                        Color
                                    </li>
                                </ul>
                              </div>
                          )}
                      </div>
                    </div>
                </div>
                
                {showByPercentage ? (
                  <>
                    {sortedGroupedBenefits.map(([percente, benefits]) => (
                      <div key={percente} className="mt-2">
                        <h1 className="text-lg text-[#007696] font-itcmedium">{percente}%:</h1>
                        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 md:grid-cols-5 gap-y-4 justify-items-center xl:grid-cols-7">
                          {benefits.map((benefit, index) => (
                            <BenefitCard 
                              key={index} 
                              benefit={benefit} 
                              onEditClick={handleEditClick} 
                              onDeleteClick={handleDeleteClick} 
                              onToggleVisibility={handleToggleVisibility}
                            />
                          ))}
                        </div>
                      </div>
                    ))}
                  </>
                ) : showByExclusive ? (
                  <>
                    {Object.entries(groupedBenefits).map(([exclusive, benefits]) => (
                      <div key={exclusive} className="mt-2">
                        <h1 className="text-lg text-[#007696] font-itcmedium">
                          {exclusive === "True" ? "Exclusivo" : "No exclusivo"}:
                        </h1>
                        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 md:grid-cols-5 gap-y-4 justify-items-center xl:grid-cols-7">
                          {benefits.map((benefit, index) => (
                            <BenefitCard
                              key={index}
                              benefit={benefit}
                              onEditClick={handleEditClick}
                              onDeleteClick={handleDeleteClick}
                              onToggleVisibility={handleToggleVisibility}
                            />
                          ))}
                        </div>
                      </div>
                    ))}
                  </>
                ) : showByColor ? (  <>
                  {Object.entries(groupedBenefits).map(([color, benefits]) => (
                    <div key={color} className="mt-2">
                      <div className="flex items-center gap-2 text-lg font-itcmedium">
                        <h1 className=" text-[#007696] font-itcmedium">
                          Color:
                        </h1>
                        <div style={{ backgroundColor: color }} className="w-[10px] rounded-full h-[10px] "></div>
                        <span style={{ color: color }} className="uppercase">
                            {color}
                        </span>
                      </div>
                      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 md:grid-cols-5 gap-y-4 justify-items-center xl:grid-cols-7">
                        {benefits.map((benefit, index) => (
                          <BenefitCard
                            key={index}
                            benefit={benefit}
                            onEditClick={handleEditClick}
                            onDeleteClick={handleDeleteClick}
                            onToggleVisibility={handleToggleVisibility}
                          />
                        ))}
                      </div>
                    </div>
                  ))}
                </>
                ) : (
                  <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 md:grid-cols-5 gap-y-4 justify-items-center xl:grid-cols-7">
                    {benefits.map((benefit, index) => (
                      <BenefitCard
                        key={index}
                        benefit={benefit}
                        onEditClick={handleEditClick}
                        onDeleteClick={handleDeleteClick}
                        onToggleVisibility={handleToggleVisibility}
                      />
                    ))}
                  </div>
                )}

            </div>
        </div>
      </div>
       
      {showModalSuccess && (
        <ModalSuccess 
            showModalSuccess={showModalSuccess}
            text={modalSuccessText}
            closeModalSuccess={handleCloseModalSuccess}
            fill="green"
        />
       )}
      {showModalDelete && (
        <ModalDelete
          showModalDelete={showModalDelete}
          closeModal={() => setShowModalDelete(false)}
          accept={handleDeleteConfirm}
        />
      )}
      {showModalAlertPercente && (
        <ModalAlertPercente
          showModalAlertPercente={showModalAlertPercente}
          closeModal={() => setShowModalAlertPercente(false)}
        />
      )}

{showModalWarning && (
  <ModalAlertWarning
    showModalAlertWarning={showModalWarning}
    closeModal={() => setShowModalWarning(false)}
    error={modalWarningMessage}
  />
)}


    </div>
  );
}